import React from "react";
import { SequenceTextWithIcon } from "../../SequenceTextWithIcon";
import { TextWithIcon } from "../../TextWithIcon";
import { CombinedStatusConfig } from "../combinedStatusUtil";

type CombinedStatusRendererProps = {
  config: CombinedStatusConfig;
};

/**
 * Renders combined status using either TextWithIcon or SequenceTextWithIcon
 * based on whether there are multiple status items.
 *
 * This component encapsulates the logic for rendering combined status
 */
export const CombinedStatusRenderer: React.FC<CombinedStatusRendererProps> = ({ config }) => {
  if (!config) return null;

  if (config.items && config.items.length > 1) {
    return <SequenceTextWithIcon items={config.items} />;
  }

  return (
    <TextWithIcon
      label={config.label}
      labelColor={config.labelColor}
      iconType={config.iconType}
      iconColor={config.iconColor}
      iconVariant={config.iconVariant}
    />
  );
};
